"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DslRuntimeSymbol = Symbol.for('DslRuntime');
//# sourceMappingURL=dsl-runtime.js.map